/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'car': {
    width: 24,
    height: 18,
    viewBox: '0 0 24 18',
    data: '<path pid="0" d="M22.506 5.031c.36 0 .629.36.539.674l-.27 1.078c-.044.27-.27.404-.494.404h-.943c.629.54 1.033 1.303 1.033 2.157V11.5c0 .764-.314 1.393-.719 1.887v2.425c0 .81-.674 1.438-1.437 1.438h-1.438a1.42 1.42 0 01-1.437-1.438v-1.437H5.84v1.438c0 .808-.674 1.437-1.438 1.437H2.965a1.42 1.42 0 01-1.438-1.438v-2.425A2.728 2.728 0 01.81 11.5V9.344a2.8 2.8 0 01.988-2.156H.898c-.27 0-.494-.135-.539-.405L.09 5.705C0 5.391.27 5.031.63 5.031h2.65l.764-1.842A5.015 5.015 0 018.715 0h5.705a5.015 5.015 0 014.672 3.19l.764 1.841h2.65zM6.693 4.268l-.853 2.2h11.5l-.899-2.2c-.359-.854-1.123-1.393-2.021-1.393H8.715c-.899 0-1.662.54-2.022 1.393zM4.403 11.5c.853 0 2.156.135 2.156-.719 0-.853-1.303-2.156-2.157-2.156-.898 0-1.437.584-1.437 1.438 0 .898.539 1.437 1.437 1.437zm14.374 0c.854 0 1.438-.54 1.438-1.438 0-.853-.584-1.437-1.438-1.437-.898 0-2.156 1.303-2.156 2.156 0 .854 1.258.719 2.156.719z" _fill="#3E4749"/>'
  }
})
